import React from "react";
import logo from "../assets/images/Senshoha_Short.png";

const Navbar = () => (
  <header className="fixed top-0 left-0 w-full z-50 bg-black/80 backdrop-blur-md shadow-md">
    <nav className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
      <div className="flex flex-col items-start space-y-0.5">
        <a href="#hero" className="flex items-center space-x-3 group" title="Go to top">
          <img
            src={logo}
            alt="Senshoha Logo"
            className="w-14 h-14 rounded-full shadow-md group-hover:ring-2 group-hover:ring-gold transition"
            style={{ objectFit: "cover" }}
          />
          <span className="text-2xl font-serif font-bold text-gold group-hover:text-white transition">
            Senshoha&nbsp;Systems
          </span>
        </a>
        <span className="hidden md:block text-xs text-gold/70 font-semibold tracking-widest ml-14">
          Intelligence in Every Inch
        </span>
      </div>
      <div className="hidden md:flex items-center space-x-8">
        <a href="#modules" className="text-gray-300 hover:text-gold transition-colors font-medium">Modules</a>
        <a href="#about" className="text-gray-300 hover:text-gold transition-colors font-medium">About</a>
        <a href="#contact" className="text-gray-300 hover:text-gold transition-colors font-medium">Contact</a>
      </div>
    </nav>
  </header>
);

export default Navbar;
